import { initialProspect } from '../prospects/models/prospect_model';
import estado_solicitud_model from '../../shared/models/estado_solicitud_model';
const today = new Date();
const FechaDesde = new Date(today);
FechaDesde.setDate(today.getDate() - 60);
FechaDesde.setHours(0, 0, 0, 0);

export const initial_proposal = {
  Codigo: null,
  CodigoCliente: null,
  CodigoUsuarioActualizacion: null,
  CodigoUsuarioCreacion: null,
  CodigoVendedor: null,
  Idioma: 'es',
  FechaCreacion: null,
  FechaActualizacion: null,
  Validez: 10,
  Textos: '',
  PropuestaCotizacionCantidad: [],
  Cliente: structuredClone(initialProspect),
  UsuarioVendedor: {
    Codigo: null,
    Usuario: '',
    Nombre: '',
    Apellido: '',
    Descripcion: '',
  },
};

export const initial_proposals_filters = {
  FechaDesde,
  FechaHasta: new Date(new Date().setHours(23, 59, 59, 999)),
  CodigoVendedor: null,
  Cliente: null,
  Referencia: null,
  CodigoCotizacion: null,
  CodigoEquivalente: null,
  CodigoAdicional: null,
  DescripcionComercial: null,
  CodigoEspecificacionTecnica: null,
  Estado: { ...estado_solicitud_model },
  CodigoUsabilidad: null,
  CodigoPropuesta: null,
};
